import React from 'react'
import { Box } from '@mantine/core'
import { Redirect } from 'react-router-dom'
import { useSlopLibraryFeed } from './hooks/useSlopLibraryFeed'
import SlopFeedPageHeader from './SlopFeedPageHeader'
import SlopSecondaryNav from './SlopSecondaryNav'
import SlopEmbedAdmin from './SlopEmbedAdmin'
import { slopFeedPageShellSx } from './slopFeedLayout'

/** Admin-only route for embedding third-party videos into the library. */
export default function SlopEmbedPage () {
  const feed = useSlopLibraryFeed({ loadLibraryFeed: false })

  if (!feed.isAdmin) {
    return <Redirect to="/slop-feed/library" />
  }

  return (
    <Box sx={slopFeedPageShellSx}>
      <SlopSecondaryNav mode="embed" />
      <SlopFeedPageHeader variant="embed" />
      <SlopEmbedAdmin
        embedUrl={feed.embedUrl}
        setEmbedUrl={feed.setEmbedUrl}
        embedTitle={feed.embedTitle}
        setEmbedTitle={feed.setEmbedTitle}
        embedDescription={feed.embedDescription}
        setEmbedDescription={feed.setEmbedDescription}
        embedLoading={feed.embedLoading}
        embedError={feed.embedError}
        handleAddEmbed={feed.handleAddEmbed}
      />
    </Box>
  )
}
